import { removeAccents } from '~/single-page/utils/removeAccents';

/**
 * Hook personalizado para realizar buscas normalizadas (sem acentos e case insensitive)
 * @param {Array} items - Array de itens para filtrar
 * @param {string} searchTerm - Termo de busca
 * @param {Array<string>} fields - Array de campos para buscar (suporta notação com ponto para objetos aninhados e arrays)
 * @returns {Array} - Array filtrado de itens
 * 
 * Exemplo de uso:
 * const filteredItems = useNormalizedSearch(items, searchTerm, ['name', 'description', 'ongs.name']);
 */
export const useNormalizedSearch = (items = [], searchTerm = '', fields = []) => {
  if (!items?.length || !searchTerm || !fields?.length) return items;

  const normalizedSearchTerm = removeAccents(searchTerm.toLowerCase());
  
  return items.filter(item => {
    return fields.some(field => {
      const keys = field.split('.');
      let value = item;
      
      for (const key of keys) {
        if (Array.isArray(value)) {
          return value.some(v => {
            const arrayValue = v[key];
            if (!arrayValue) return false;
            
            const normalizedValue = removeAccents(arrayValue.toString().toLowerCase());
            return normalizedValue.includes(normalizedSearchTerm);
          });
        }
        
        value = value?.[key];
        if (!value) return false;
      }
      
      const normalizedValue = removeAccents(value.toString().toLowerCase());
      return normalizedValue.includes(normalizedSearchTerm);
    });
  });
};